import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'it-splitter',
  standalone: true,
  templateUrl: './it-splitter.component.html',
  styleUrls: ['./it-splitter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItSplitterComponent {
  @Output() resizeWidth = new EventEmitter<number>();

  private isResizing = false;

  onStartResize(ev: MouseEvent | TouchEvent): void {
    ev.preventDefault();

    const startX = this.getClientX(ev);
    const startWidth = this.getCurrentResponseWidthFromCss(ev);

    this.isResizing = true;
    document.body.classList.add('it-resizing');

    const onMove = (e: MouseEvent | TouchEvent) => {
      if (!this.isResizing) return;
      const x = this.getClientX(e);

      // moving LEFT increases response width; moving RIGHT decreases it
      const dx = startX - x;
      this.resizeWidth.emit(startWidth + dx);
    };

    const onUp = () => {
      this.isResizing = false;
      document.body.classList.remove('it-resizing');

      window.removeEventListener('mousemove', onMove as any);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove as any);
      window.removeEventListener('touchend', onUp);
    };

    window.addEventListener('mousemove', onMove as any, { passive: false });
    window.addEventListener('mouseup', onUp, { passive: true });
    window.addEventListener('touchmove', onMove as any, { passive: false });
    window.addEventListener('touchend', onUp, { passive: true });
  }

  private getClientX(ev: MouseEvent | TouchEvent): number {
    const te = ev as TouchEvent;
    if (te.touches && te.touches.length) return te.touches[0].clientX;
    return (ev as MouseEvent).clientX;
  }

  private getCurrentResponseWidthFromCss(ev: MouseEvent | TouchEvent): number {
    // Read from the element that actually has --resp-w (your shell sets it on .it-mid / .it-page)
    const target = ev.target as HTMLElement | null;

    const host =
      target?.closest?.('.it-mid') ||
      target?.closest?.('.it-page') ||
      document.querySelector('.it-mid') ||
      document.querySelector('.it-page') ||
      document.documentElement;

    const raw = getComputedStyle(host as Element).getPropertyValue('--resp-w').trim();
    const n = Number(raw.replace('px', '').trim());
    return Number.isFinite(n) && n > 0 ? n : 560;
  }
}
